/* eslint-disable import/prefer-default-export */
export const ptBR = {
  pt: {
    generals: {
      seework: "Veja o trabalho | {1} Veja os trabalhos",
      offices: "Todos Escritórios",
      read: "Leia o artigo",
      related: "Projetos Relacionados",
      "related-news": "Notícias Relacionadas",
      readmore: "Ler mais",
      seemore: "Veja mais",
      getcontact: "Entrar em contato",
      ourclients: "Nossos clientes",
      apply: "Aplique",
      jobsfounded: "Em breve...",
      error: "Algo deu errado, tente novamente...",
      employeesfounded: "Nenhum funcionário encontrado...",
      clientsfounded: "Nenhum cliente encontrado...",
      newsfounded: "Nenhuma notícia encontrada...",
      contactsfounded: "Nenhum contato encontrado...",
    },
    menus: {
      work: "Trabalhos",
      news: "Notícias",
      about: "Sobre",
      contact: "Contato",
    },
    search: {
      placeholder: "O que você está procurando?",
      results: "resultado encontrado | {2} resultados encontrados",
      filter: "Filtro",
      columns: {
        offices: "Escritório",
        types: "Tipo",
        customers: "Cliente",
        years: "Ano",
      },
    },
    singleWork: {
      office: "Escritório",
      date: "Data",
      client: "Cliente",
    },
    footer: {
      copyright: "Todos os direitos reservados",
      followus: "Siga-nos no",
      weare: "Nós somos",
    },
    contact: {
      talkwithus: "Fale <br /> Conosco",
      workwithus: "Trabalhe <br/> Conosco",
      talents: "Novos talentos",
      talentdescription:
        "Venha trabalhar na agência mais criativa do mundo. <br /> Ou se você não acha que essa é a agência mais criativa do mundo: <br /> Venha trabalhar na DAVID. É sua chance de fazer dela a agência mais criativa do mundo.",
      general: "Contato geral",
      vacanciesnotfound:
        "Neste momento não temos proceso de seleção aberto, <br />mas podes sempre mandar-nos um olá.",
    },
  },
};
